import {fetchClientProjects} from "../requests/ClientRequests";

const QueryOptions = {
    // Client Lead
    'fetchAppSheetOptionsForClient': {
        retry: false,
        refetchOnMount: true,
        structuralSharing: true
    },
    'fetchAppSheetOptionsForProjectPosition': {
        retry: false,
        refetchOnMount: true,
        structuralSharing: true
    },
    'fetchAppSheetOptionsForProject': {
        retry: false,
        refetchOnMount: false,
        structuralSharing: true
    },
    // Supplier/Agency
    'fetchSupplierDashboard': {
        retry: false,
        refetchOnMount: true,
    },

    'fetchAllSupplierOpportunities': {
        retry: false,
    },
    'fetchSupplierTalentResource': {
        retry: false,
    },
    'fetchAllSupplierTalentResources': {
        retry: false,
        refetchOnMount: false,
    },
    'fetchTalentResourcesForJobBoard': {
        retry: false,
        refetchOnMount: true,
        keepPreviousData: true,
    },
    'fetchOpportunityForAgency': {
        retry: false,
        refetchOnMount: true,
        refetchOnWindowFocus: false,
        keepPreviousData: false,
        structuralSharing: true,
    },
    'fetchServiceOfferingTags': {
        retry: false,
        refetchOnMount: true,
        refetchOnWindowFocus: false,
        keepPreviousData: true,
        structuralSharing: true,
    },
    'fetchPartnerPrograms': {
        retry: false,
        refetchOnMount: true,
        refetchOnWindowFocus: false,
        keepPreviousData: true,
        structuralSharing: true,
    },


    // Client
    'fetchClientProjectGroups': {
        refetchOnMount: true,
    },
    'fetchClientUsers': {
        refetchOnMount: false,
        retry: true,
    },
    'fetchClientProjects': {
        refetchOnMount: true,
        keepPreviousData: false,
    },
    'fetchTalentPools': {
        retry: true,
    },
    'fetchTalentPoolDetail': {
        retry: true,
    },
    'searchForTalent': {
        refetchOnMount: false,
        retry: false,
    },
    'searchForTeams': {
        refetchOnMount: false,
        retry: false,
    },
    'searchForSuppliers': {
        refetchOnMount: false,
        retry: false,
    },

    // Client - Project
    'fetchProject': {
        retry: false,
        refetchOnMount: false,
        keepPreviousData: false,
        structuralSharing: true,
    },
    'searchProjectKeywords': {
        retry: false
    },
    'fetchGreenlightOptionsForCandidate': {
        retry: true,
        refetchOnMount: true,
        keepPreviousData: true,
        structuralSharing: false,
    },
    'searchTalentSkills': {
        retry: true,
        keepPreviousData: false,
        structuralSharing: true,
    },

    // Client - Financials
    'fetchTalentTimePayments': {
        refetchOnMount: false,
        retry: false,
        keepPreviousData: true,
    },
    // Contract values change as change orders are booked, and the figures are
    // client scoped, so this view always pulls fresh rather than painting a
    // previous result while it revalidates.
    'fetchContractProgression': {
        retry: false,
        refetchOnMount: 'always',
        keepPreviousData: false,
        staleTime: 0,
        cacheTime: 0,
    },
    // Burn is measured against live payout records, so a stale copy would
    // understate spend. Same freshness contract as the contract progression.
    'fetchProjectBurnSpend': {
        retry: false,
        refetchOnMount: 'always',
        keepPreviousData: false,
        staleTime: 0,
        cacheTime: 0,
    },

    // Client - Service/Teams
    'fetchAllServices': {
        retry: true,
        refetchOnMount: true,
        keepPreviousData: false,
        structuralSharing: false,
    },
    'fetchServicesByCategory': {},

    'teamMatches': {
        keepPreviousData: false,
        retry: false,
        refetchOnMount: true,
        staleTime: 200000,
    },
    'fetchTeamCandidateScope': {
        retry: false,
        refetchOnMount: true,
    },
    'fetchTemplatesFromTags': {},
    'searchProjectTemplateTags': {},
    'fetchProjectTemplate': {
        keepPreviousData: true,
        structuralSharing: true,
        retry: false,
    },

    // Client - BYO/ProjectPosition
    'positionMatches': {
        keepPreviousData: false,
        retry: false,
        refetchOnMount: false,
        staleTime: 200000,
    },
    'getPositionMatchingTalentCount': {
        keepPreviousData: true,
        retry: true,
        refetchOnMount: false,
        staleTime: 200000,
    },
    'fetchTalentCandidateScope': {
        retry: false,
        refetchOnMount: true,
    },
    'searchPositionTemplateTags': {},
    'fetchSharableForPosition': {
        retry: false,
        keepPreviousData: false,
        refetchOnMount: false,
    },
    'searchDeliverablesByDisciplines' : {
        refetchOnMount: true,
    },
    'searchCandidates': {
        keepPreviousData: false,
        retry: false,
        refetchOnMount: true,
        staleTime: 200000,
    },
    'fetchRecipientUsers': {
        retry: false,
        keepPreviousData: false,
        refetchOnMount: true,
    },


    // Talent
    'fetchOpportunityForTalent': {
        retry: false,
        refetchOnMount: true,
        refetchOnWindowFocus: false,
        keepPreviousData: false,
        structuralSharing: true,
    },
    'fetchTalentTeam': {
        retry: false
    },
    'fetchJobBoardForTalent': {
        retry: false,
        refetchOnMount: false,
        keepPreviousData: true,
    },
    'fetchCoverLettersForTalent': {
        retry: true,
        refetchOnMount: false,
        keepPreviousData: true,
    },
    'fetchJobBoardDetails': {
        retry: false,
        refetchOnMount: false,
    },
    'fetchAllTeamsForTalent': {},
    'searchAllTalentForMemberInvite': {
        retry: false,
        refetchOnMount: false,
        keepPreviousData: false,
    },
    'fetchLatestVideoInterviewForTalent': {
        retry: false,
        refetchOnMount: false,
        keepPreviousData: false,
        structuralSharing: true,
    },
    'searchTagsExpertise': {
        retry: false,
        refetchOnMount: false,
        keepPreviousData: false,
    },
    'searchBrands': {
        retry: false,
        refetchOnMount: false,
        keepPreviousData: true,
    },







    // SHARED
    'fetchMeetings': {
        // retry: false,
        refetchOnMount: true,
    },
    'markProposalAsViewed': {
        retry: false,
        cacheTime: 15000,
        refetchOnMount: false,
    },
    'fetchTalent': {
        retry: false,
        refetchOnMount: true
    },
    'fetchClient': {},
    'fetchTeam': {
        retry: false
    },
    'fetchUserNotificationSettings': {
        retry: false,
        refetchOnMount: true,
    }
}

export default QueryOptions;